// extracted by mini-css-extract-plugin
module.exports = {"container":"Label_container__1tPkN","label":"Label_label__2ON6P","required":"Label_required__1BuDm"};